(function () {
  'use strict';

  if (window.__hhBuyCardLoaded) return;
  window.__hhBuyCardLoaded = true;

  /* Uses the shop's own money_format string, the same locale template behind Liquid's
     money filter, for quantities that can only be priced after the shopper taps. */
  /* Smallest amount the shopper's currency can actually express, in minor units. Yen has no
     sub-unit, so every real JPY price is a multiple of 100 here, and a price that is not one
     cannot be charged. Read from the money format because that is the only per-currency
     precision signal the storefront gives the theme. */
  function minorStep(format) {
    return /amount_no_decimals/.test(String(format || '')) ? 100 : 1;
  }

  function money(cents, format) {
    var template = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var settings = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.']
    };
    var chosen = settings[placeholder] || settings.amount;
    var value = (Number(cents || 0) / 100).toFixed(chosen[0]);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, chosen[1]);
    value = parts.length > 1 ? parts[0] + chosen[2] + parts[1] : parts[0];
    return match ? template.replace(match[0], value) : value;
  }

  function parseTierTable(root) {
    return (root.getAttribute('data-tier-table') || '').split('|').map(function (record) {
      var parts = record.split(':');
      return {
        min: Number(parts[0]),
        max: parts[1] === '' ? Infinity : Number(parts[1]),
        discount: Number(parts[2])
      };
    }).filter(function (tier) {
      return tier.min > 0 && tier.max >= tier.min && tier.discount >= 0;
    });
  }

  /* Same end-of-rail affordance as the pack builder. The fade disappears once the
     shopper reaches the final column and returns if the rail is scrolled back. */
  function bindRailFade(root) {
    var wrap = root.querySelector('.hh-bc__discs-wrap');
    var rail = root.querySelector('.hh-bc__discs');
    var previous = root.querySelector('.hh-bc__rail-arrow--previous');
    var next = root.querySelector('.hh-bc__rail-arrow--next');
    if (!wrap || !rail || rail.getAttribute('data-fade-ready') === 'true') return;
    rail.setAttribute('data-fade-ready', 'true');
    function setDisabled(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
    function columnWidth() {
      var discs = Array.prototype.slice.call(rail.querySelectorAll('.hh-bc__disc'));
      var firstLeft;
      var index;
      if (!discs.length) return 0;
      firstLeft = discs[0].offsetLeft;
      for (index = 1; index < discs.length; index += 1) {
        if (Math.abs(discs[index].offsetLeft - firstLeft) > 8) return Math.abs(discs[index].offsetLeft - firstLeft);
      }
      return discs[0].offsetWidth;
    }
    function move(direction) {
      var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var distance = Math.max(0, rail.clientWidth - columnWidth());
      var target = Math.max(0, Math.min(maxScroll, rail.scrollLeft + (distance * direction)));
      /* Keeping one column visible preserves context while the rest of the visible rail advances. */
      if ('scrollBehavior' in document.documentElement.style && typeof rail.scrollTo === 'function') {
        try {
          rail.scrollTo({ left: target, behavior: 'smooth' });
          return;
        } catch (error) {}
      }
      rail.scrollLeft = target;
    }
    function sync() {
      var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var hasOverflow = maxScroll > 8;
      var more = maxScroll - rail.scrollLeft > 8;
      if (more) {
        if (wrap.className.indexOf('is-scrollable') < 0) wrap.className += ' is-scrollable';
      } else {
        wrap.className = wrap.className.replace(/\s*is-scrollable/g, '');
      }
      if (hasOverflow) {
        if (wrap.className.indexOf('has-rail-overflow') < 0) wrap.className += ' has-rail-overflow';
      } else {
        wrap.className = wrap.className.replace(/\s*has-rail-overflow/g, '');
      }
      setDisabled(previous, !hasOverflow || rail.scrollLeft <= 8);
      setDisabled(next, !hasOverflow || !more);
    }
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.setTimeout(sync, 0);
    sync();
  }

  function init(root) {
    if (!root || root.getAttribute('data-hh-buy-card-ready') === 'true' || !window.HHCartTruth) return;
    root.setAttribute('data-hh-buy-card-ready', 'true');

    var tiers = parseTierTable(root);
    var discs = Array.prototype.slice.call(root.querySelectorAll('.hh-bc__disc'));
    var available = [];
    var selected = null;
    var chosen = [];
    /* The variant id of the colour the card seeded for the shopper, or null once the shopper has
       made a choice of their own. It marks `chosen` as a SUGGESTION rather than a decision, which
       is what tapDisc() and changeChoice() below consult before mutating it. */
    var seededVariant = null;
    /* Declared up here because setDiscState() reads it and is defined above the pair block. */
    var pairMode = false;
    var pairSize = 2;
    var pairChoice = [null, null];
    /* True while a slot still holds the colour the CARD chose at landing rather than one the
       shopper picked. pairCommit's advance rule keys off this: "still the default" is the new
       "still empty". Without it, seeding both slots made
       `if (!pairChoice[other])` permanently false and two rail taps both landed on slot 0. */
    var pairSeeded = [false, false];
    var adding = false;
    /* Bumped once per add. unconfirmed()'s cart re-read is not cancellable, so it
       compares this before restating a message the shopper has already moved past. */
    var attempt = 0;
    var cartState = window.HHCartTruth.get();
    /* img[data-hero], NOT [data-hero]. Every .hh-bc__disc also carries a data-hero URL
       (snippets/hh-buy-card.liquid line 576), and the media image this variable is meant to hold
       only renders when the placement is not the PDP. So on the PDP the bare selector matched the
       FIRST DISC instead of null, and showDisc() then set opacity .35 on the Black disc for the
       length of a 1200px preload every time any colour was tapped. Homepage is unaffected: its
       media img is emitted above the rail, so it already won the bare selector. */
    var hero = root.querySelector('img[data-hero]');
    var segments = Array.prototype.slice.call(root.querySelectorAll('.hh-bc__segment'));
    var ticks = Array.prototype.slice.call(root.querySelectorAll('.hh-bc__tick'));
    var segs = root.querySelector('[data-segs]');
    var summary = root.querySelector('[data-summary]');
    var summaryCompare = root.querySelector('[data-summary-compare]');
    var summaryTotal = root.querySelector('[data-summary-total]');
    var summaryCurrency = root.querySelector('[data-summary-currency]');
    var liveStatus = root.querySelector('[data-live-status]');
    var add = root.querySelector('[data-add]');
    var hint = root.querySelector('[data-hint]');
    /* addToCart outcomes are staged here instead of written straight to `hint`,
       because render() rewrites hint in every one of its branches and addToCart
       calls render() on the next line, erasing it. render() takes this once at
       the top and clears it, so the message shows in whichever branch renders
       next and never lingers past it. Same idea as `feedback` in
       hh-pack-builder.js. */
    var pendingHint = '';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var copyCta = root.getAttribute('data-copy-cta') || 'ADD TO CART';
    var copyCtaCount = root.getAttribute('data-copy-cta-count') || 'Add {count} to Cart';
    /* The empty-state label was already wired through to the root as data-copy-cta-empty and
       server-rendered onto the button, but nothing here ever read it, so the first render
       replaced "Pick a color to start" with a priced ADD TO CART on a button that stays
       aria-disabled until a colour is committed. */
    var copyCtaEmpty = root.getAttribute('data-copy-cta-empty') || 'Pick a color to start';
    /* Zero quantity is NOT the same as nothing chosen. The first tap on a colour previews it
       without adding quantity, so chosenCount stays 0 while a colour is plainly selected.
       "Pick a color to start" would be the wrong instruction in that state; the remaining step
       is the plus control. This attribute was already emitted alongside the empty one. */
    var copyCtaPreview = root.getAttribute('data-copy-cta-preview') || 'Tap + to add';
    var copyItem = root.getAttribute('data-copy-item') || 'Hit Hero';
    var copyItemPlural = root.getAttribute('data-copy-item-plural') || 'Hit Heroes';
    var copyPackNote = root.getAttribute('data-copy-pack-note') || 'Adding:';

    discs.forEach(function (disc) {
      if (disc.getAttribute('data-available') === 'true') available.push(disc);
    });
    function validNumber(value) { return typeof value === 'number' && isFinite(value) && value > 0; }
    var localBaseCents = Number(root.getAttribute('data-local-base-cents')) || 0;
    function discountFor(quantity) {
      for (var i = 0; i < tiers.length; i += 1) {
        if (tiers[i].min <= quantity && quantity <= tiers[i].max) return tiers[i].discount;
      }
      return null;
    }
    /* Whatever this returns is the price the shopper is promised before they commit, so it has
       to track the volume discount function rather than merely be defensible arithmetic. Two
       things were learned by adding to a real cart and reading /cart.js back in each currency.

       The function prices a single unit and then multiplies, so applying the percentage to the
       line total and rounding once under-quoted CAD by 1 cent at 3 units, 4 at 6 and 9 at 12.

       That unit price is then expressed in whole units of the shopper's currency. Yen has no
       sub-unit, so rounding to the nearest cent produced prices like 2674.56 yen, which cannot
       be charged, and the card under-quoted every JPY pack: 1 yen at 2 units, 2 at 3, 6 at 6
       and 6 at 12.

       Rounding up to the currency's real step fixes both and is the safe direction by design:
       exact at every quantity tested in CAD and JPY, and in USD at 3, 4, 6 and 12. Erring high
       means checkout can surprise a shopper by costing less, never by costing more. Verified
       against /cart.js in USD, CAD and JPY.

       The USD 2-unit residual this comment used to describe is GONE: the 829 basis-point tier
       now lands exactly on 33.00.

       KNOWN GAP, not a rounding error: this prices only what is being added and ignores what is
       already in the cart, while the discount function tiers on TOTAL eligible cart quantity.
       With one guard already in the cart, a two-pack quotes the 2-unit tier while the cart
       qualifies for the 3-unit tier. That is an OVERQUOTE, so checkout still only ever surprises
       downward, but the two numbers differ. Fixing it means quoting from cart truth, not from
       `chosen.length`. */
    function priceFor(quantity) {
      var discount = discountFor(quantity);
      var step = minorStep(moneyFormat);
      var compare;
      var unitPrice;
      var total;
      if (!validNumber(localBaseCents) || !validNumber(quantity) || discount === null) return null;
      compare = localBaseCents * quantity;
      unitPrice = Math.ceil(localBaseCents * (10000 - discount) / 10000 / step) * step;
      total = unitPrice * quantity;
      return {
        compare: compare,
        total: total,
        savings: compare - total
      };
    }
    /* The button label is built from nodes rather than assigned as textContent, because the
       compare price has to be struck and dimmed and a plain string cannot carry that. Every
       other CTA state still uses textContent, which wipes these children on the way past. */
    function setAddLabel(label, pricing) {
      var strike;
      if (!add) return;
      add.textContent = label;
      if (!pricing || pricing.savings <= 0) return;
      strike = document.createElement('s');
      strike.className = 'hh-bc__add-compare';
      strike.textContent = money(pricing.compare, moneyFormat);
      add.appendChild(strike);
    }
    function setAddDisabled(disabled) {
      if (add) add.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
    function countFor(variantId) {
      return chosen.filter(function (choice) { return choice === variantId; }).length;
    }
    function setDiscState() {
      discs.forEach(function (disc) {
        var variantId = disc.getAttribute('data-variant-id');
        var count = countFor(variantId);
        var name = disc.getAttribute('data-name') || '';
        var isAvailable = disc.getAttribute('data-available') === 'true';
        var state = count > 0 ? 'added' : (disc === selected ? 'previewing' : 'untouched');
        var body = disc.querySelector('[data-disc-body]');
        var stepper = disc.querySelector('[data-disc-stepper]');
        var countOut = disc.querySelector('[data-disc-quantity]');
        var controls = stepper ? stepper.querySelectorAll('button') : [];
        var index;
        disc.setAttribute('data-disc-state', state);
        disc.setAttribute('data-current-choice', disc === selected ? 'true' : 'false');
        if (countOut) countOut.textContent = String(count);
        if (stepper) {
          /* The stepper is the multi-quantity control, and in pair mode the slot count IS the
             quantity, so it must stay hidden through every render. Hiding it once at init was
             not enough: this runs on each render and put it straight back. */
          stepper.hidden = pairMode || !isAvailable || state === 'untouched';
          stepper.setAttribute('aria-hidden', stepper.hidden ? 'true' : 'false');
          stepper.setAttribute('aria-label', name + ', quantity ' + String(count));
        }
        if (body) {
          body.setAttribute('aria-pressed', state === 'untouched' ? 'false' : 'true');
          body.disabled = !isAvailable || adding;
          if (!isAvailable) {
            body.setAttribute('aria-disabled', 'true');
            body.setAttribute('aria-label', name + ', sold out, quantity 0.');
          } else {
            if (adding) body.setAttribute('aria-disabled', 'true');
            else body.removeAttribute('aria-disabled');
            body.setAttribute('aria-label', name + ', quantity ' + String(count) + '.');
          }
        }
        for (index = 0; index < controls.length; index += 1) {
          controls[index].disabled = adding || !isAvailable;
          if (adding || !isAvailable) controls[index].setAttribute('aria-disabled', 'true');
          else controls[index].removeAttribute('aria-disabled');
        }
      });
    }
    function discFor(variantId) {
      for (var index = 0; index < discs.length; index += 1) {
        if (discs[index].getAttribute('data-variant-id') === variantId) return discs[index];
      }
      return null;
    }
    function renderMeter(quantity) {
      var previous = 0;
      var index;
      var min;
      var fill;
      var progress;
      var cap;
      var second;
      var last;
      var topIndex;
      for (index = 0; index < segments.length; index += 1) {
        min = Number(segments[index].getAttribute('data-min'));
        fill = segments[index].querySelector('i');
        progress = min > previous ? Math.max(0, Math.min(1, (quantity - previous) / (min - previous))) : 0;
        if (fill) fill.style.width = Math.round(progress * 100) + '%';
        previous = min;
      }
      /* Only the tier the order currently STANDS at is marked. The `hit` class that used to be
         set on every passed tier is gone: once colour stopped meaning "cleared" and started
         meaning "you are here", nothing styled it, and a class the CSS never reads is a trap
         for the next reader. Ticks are emitted in ascending tier order, so the last index whose
         minimum is satisfied is the highest reached one.

         Two passes rather than one because the winner is not known until every tick has been
         examined. */
      topIndex = -1;
      for (index = 0; index < ticks.length; index += 1) {
        min = Number(ticks[index].getAttribute('data-min'));
        if (quantity >= min) topIndex = index;
      }
      for (index = 0; index < ticks.length; index += 1) {
        if (index === topIndex && ticks[index].className.indexOf('is-top') < 0) ticks[index].className += ' is-top';
        if (index !== topIndex) ticks[index].className = ticks[index].className.replace(/\s*\bis-top\b/g, '');
      }
      if (!segs || !segments.length) return;
      cap = Number(segments[segments.length - 1].getAttribute('data-min'));
      second = ticks[1] && quantity >= Number(ticks[1].getAttribute('data-min'));
      last = ticks.length && quantity >= Number(ticks[ticks.length - 1].getAttribute('data-min'));
      if (quantity < 1) { segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15)'; return; }
      if (last) segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15),0 0 18px rgba(176,235,116,.95)';
      else if (second) segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15),0 0 ' + Math.round(12 + 6 * Math.max(0, Math.min(1, quantity / cap))) + 'px rgba(154,227,63,.82)';
      else segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15),0 0 ' + Math.round(4 + 10 * Math.max(0, Math.min(1, quantity / cap))) + 'px rgba(242,24,250,' + (0.15 + 0.45 * Math.max(0, Math.min(1, quantity / cap))).toFixed(2) + ')';
    }
    function syncChoiceUi(showSelection) {
      setDiscState();
      if (showSelection) showCurrentSelection();
    }
    var placement = root.getAttribute('data-placement') || 'homepage';
    /* Pair zone. Homepage only. The card already owned a per-colour rail, the quote maths and
       the cart handler, so this is a mode on that card rather than a second purchase module.
       Two purchase surfaces on one page would mean two cart handlers and would reopen the
       hint-overwrite bug class. The rail's own steppers stay hidden while this is on, and one
       tap commits a colour into the next empty slot instead of the rail's two-tap preview. */
    var mode = root.getAttribute('data-mode') || 'pair';
    var pairZone = mode === 'pair' ? root.querySelector('[data-pair]') : null;
    pairMode = !!pairZone;
    var pairActive = 0;
    var pairSlots = pairZone ? Array.prototype.slice.call(pairZone.querySelectorAll('[data-pair-slot]')) : [];
    /* The price row lives in the intro stack above the media now, not inside [data-pair], so
       these are queried from the card root. */
    var pairTotal = pairMode ? root.querySelector('[data-pair-total]') : null;
    var pairCurrency = pairMode ? root.querySelector('[data-pair-currency]') : null;
    var currencyCode = String(root.getAttribute('data-currency') || '').trim();
    /* Set once. The market cannot change without a navigation, and the total's own code is
       therefore not part of render()'s hot path. Left hidden when the attribute is empty
       rather than guessing a currency. */
    if (summaryCurrency) {
      summaryCurrency.textContent = currencyCode;
      summaryCurrency.hidden = !currencyCode;
    }
    var pairCompare = pairMode ? root.querySelector('[data-pair-compare]') : null;
    var copyPairCtaFirst = root.getAttribute('data-copy-pair-cta-first') || 'Pick your first color';
    var copyPairCtaSecond = root.getAttribute('data-copy-pair-cta-second') || 'Pick your second color';
    var copyPairEmpty = root.getAttribute('data-copy-pair-empty') || 'Tap to choose';

    /* The pair price is driven by quantity, not by colour, so it is painted once at load and
       never depends on a slot being filled. Showing nothing until both choices are made would
       put two decisions in front of the first price on the page whose cart-add rate is the
       problem being fixed. */
    function paintPairPrice() {
      var pricing = priceFor(pairSize);
      if (!pairZone || !pricing) return;
      if (pairTotal) pairTotal.textContent = money(pricing.total, moneyFormat);
      /* "$40.34" alone does not say CAD or USD, and this store sells into both off one symbol.
         The code comes from data-currency (localization.country.currency.iso_code), so it is
         the market's currency, not the shop's. Left hidden when the attribute is empty rather
         than guessing. */
      if (pairCurrency) {
        pairCurrency.textContent = currencyCode;
        pairCurrency.hidden = !currencyCode;
      }
      if (pairCompare) {
        pairCompare.textContent = pricing.savings > 0 ? money(pricing.compare, moneyFormat) : '';
        pairCompare.hidden = pricing.savings <= 0;
      }
    }

    function paintPair() {
      var filled = Math.min(chosen.length, pairSize);
      var i;
      var slot;
      var img;
      var name;
      var disc;
      if (!pairZone) return;
      root.setAttribute('data-slots', String(filled));
      pairZone.setAttribute('data-pair-active', String(pairActive));
      for (i = 0; i < pairSlots.length; i += 1) {
        slot = pairSlots[i];
        img = slot.querySelector('[data-pair-img]');
        name = slot.querySelector('[data-pair-name]');
        disc = pairChoice[i] ? discFor(pairChoice[i]) : null;
        slot.setAttribute('aria-pressed', i === pairActive ? 'true' : 'false');
        if (disc) {
          slot.setAttribute('data-slot-state', 'filled');
          if (img) {
            img.src = disc.getAttribute('data-front') || disc.getAttribute('data-image') || '';
            img.alt = disc.getAttribute('data-name') || '';
            img.hidden = false;
          }
          if (name) name.textContent = disc.getAttribute('data-name') || '';
        } else {
          slot.setAttribute('data-slot-state', 'empty');
          if (img) { img.hidden = true; img.removeAttribute('src'); img.alt = ''; }
          if (name) name.textContent = copyPairEmpty;
        }
      }
    }

    /* The two options are addressed by position, so a colour can be changed in place without
       disturbing the other. `chosen` stays the flat list the cart handler and the quote both
       already read, and is rebuilt from the slots rather than being the source of truth. */
    function pairSync() {
      chosen = [];
      if (pairChoice[0]) chosen.push(pairChoice[0]);
      if (pairChoice[1]) chosen.push(pairChoice[1]);
    }
    /* The reverse direction, and the reason it exists: every cart outcome empties `chosen` so a
       second tap cannot re-order what already landed. In pair mode the slots are the source
       `pairCommit()` rebuilds `chosen` FROM, so leaving them filled after a successful add
       resurrected an already-purchased colour on the next tap. Slots follow `chosen`, always. */
    function pairFollowChosen() {
      if (!pairMode) return;
      pairChoice[0] = chosen[0] || null;
      pairChoice[1] = chosen[1] || null;
      /* Slots now follow the cart outcome, so neither is the card's untouched suggestion. */
      pairSeeded[0] = false;
      pairSeeded[1] = false;
      pairActive = pairChoice[0] ? (pairChoice[1] ? 0 : 1) : 0;
    }

    function pairCommit(disc) {
      var variantId = disc.getAttribute('data-variant-id');
      var other = pairActive === 0 ? 1 : 0;
      pairChoice[pairActive] = variantId;
      /* This tap is a real choice, so the slot is no longer a suggestion. */
      pairSeeded[pairActive] = false;
      /* Advance to the other option when it is still empty OR still holds the seeded default,
         so the common path stays two taps even though each option is independently addressable.
         Before both slots were seeded, "empty" was the only way a slot could be untouched. Now
         a seeded slot is untouched too, and without this "tap Red, tap Green" wrote slot 0
         twice and produced Green/Black. Fable caught this 2026-09-22. */
      if (!pairChoice[other] || pairSeeded[other]) pairActive = other;
      pairSync();
    }

    function pairSelect(index) {
      if (adding) return;
      /* Choosing a slot by hand means the shopper is aiming at it, so the next rail tap must
         land here and stay here rather than auto-advancing off a still-seeded neighbour. */
      pairSeeded[index] = false;
      pairActive = index;
      render();
    }
    var shopSlot = root.querySelector('[data-shop-row]');
    var swapToken = 0;

    /* Ported from hh-purchase-rail.js swapPdpGallery. On the PDP this card renders no media of
       its own, so selecting a colour has to move Horizon's gallery or the shopper buys Blue
       while looking at a Black photo. */
    function swapPdpGallery(disc) {
      if (placement !== 'pdp' || !disc) return;
      /* 2026-09-23: assets/hh-pdp-gallery-variant.js is now the single writer for the PDP
         gallery (snap to slide 0, one crossfade, patch the rest in place). Painting here as well
         was the first half of the double repaint the owner saw as a shutter. */
      if (window.__hhPdpGalleryVariantBound) return;
      var next = disc.getAttribute('data-hero') || disc.getAttribute('data-image') || '';
      if (!next) return;
      var gallery = document.querySelector('.product-media-container, media-gallery, slideshow-component');
      if (!gallery) return;
      var img = gallery.querySelector('img');
      if (!img) return;
      var token = ++swapToken;
      var preload = new Image();
      preload.onload = function () {
        if (token !== swapToken) return;
        /* Horizon replaces the WHOLE media-gallery node through the Section Rendering API on a
           colour change, and it already paints every colour-aware slide correctly. This preload
           resolves asynchronously, so without this guard it lands on a node the section swap has
           already discarded, or worse repaints the NEW gallery with the PREVIOUS colour's hero.
           Verified on live 2026-09-21: the node identity changes on every disc tap. */
        if (!img.isConnected) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = next;
        img.alt = (disc.getAttribute('data-name') || '') + ' Hit Hero';
      };
      preload.src = next;
      var slideshow = document.querySelector('slideshow-component');
      if (slideshow && typeof slideshow.select === 'function') {
        try { slideshow.select(0); } catch (error) { /* gallery differs by theme version */ }
      }
    }

    function moveShopPay() {
      if (placement !== 'pdp' || !shopSlot) return null;
      var form = root.closest ? root.closest('form') : null;
      if (!form) return null;
      var accelerated = form.querySelector('.accelerated-checkout-block');
      if (accelerated && accelerated.parentNode !== shopSlot) shopSlot.appendChild(accelerated);
      return accelerated;
    }

    /* Shop Pay submits one line from the real product form. Its inputs must carry the complete
       single-variant selection BEFORE the button is reachable. This does not depend on cart-truth:
       cart verification protects the Ajax multi-line add path, while this button submits the form
       itself. Multi-variant packs cannot be represented by these two scalar inputs and stay hidden. */
    function syncShopPay() {
      if (placement !== 'pdp') return;
      if (adding) { var busy = moveShopPay(); if (busy) busy.hidden = true; root.className = root.className.replace(/\s*is-shop-ready/g, ''); return; }
      root.className = root.className.replace(/\s*is-shop-ready/g, '');
      var form = root.closest ? root.closest('form') : null;
      var accelerated = moveShopPay();
      if (accelerated) accelerated.hidden = true;
      if (!form || !accelerated) return;
      /* ONE variant, ANY quantity. Owner 2026-09-21: the Shop Pay button must not vanish when
         the shopper raises the count. It used to require `chosen.length === 1` and posted a
         hardcoded quantity of 1, so three of one colour hid the button entirely.

         The form carries two scalar inputs, an id and a quantity, which CAN express N of one
         variant and CANNOT express a mixed pack. So the gate is now "every entry is the same
         variant", not "there is exactly one entry". A mixed selection still hides the button,
         and that is correctness rather than an oversight: this control submits the form, so
         showing it over a mixed pack would check the shopper out with ONE colour while the
         screen shows several. Read the packNote() comment in render() for the same class of
         bug and why it is worth a hidden control to avoid. */
      /* Owner 2026-09-21, second pass: read the PACK, never the previewed disc. This used to
         take wantIdStr from `selected`, so merely tapping another colour to look at it made the
         previewed disc disagree with a pack that had not changed, the gate failed, and Shop Pay
         vanished. That cost 102px of height mid-browse and read as the page glitching. Browsing
         colours is not a pack edit, so it must not move this button. */
      var qty = chosen.length;
      var wantIdStr;
      var i;
      if (!qty) return;
      wantIdStr = String(chosen[0]);
      for (i = 1; i < qty; i += 1) { if (String(chosen[i]) !== wantIdStr) return; }

      var idInput = form.querySelector('input[name="id"]');
      var quantityInput = form.querySelector('input[name="quantity"]');
      if (!idInput || !quantityInput || idInput.disabled || quantityInput.disabled) return;
      var wantId = Number(wantIdStr);
      idInput.value = String(wantId);
      quantityInput.value = String(qty);
      /* Read back rather than trust the write: a disabled or re-rendered input silently drops
         it, and a Shop Pay button over a stale quantity sells the wrong number of units. */
      if (Number(idInput.value) !== wantId || Number(quantityInput.value) !== qty) return;

      accelerated.hidden = false;
      root.className += ' is-shop-ready';
    }

    var heroToken = 0;
    var warmed = false;
    function warmHeroes() {
      if (warmed) return;
      warmed = true;
      for (var i = 0; i < discs.length; i += 1) {
        var u = discs[i].getAttribute('data-hero');
        if (u) { var img = new Image(); img.src = u; }
      }
    }

    function restoreDefaultHero() {
      var fallback = root.getAttribute('data-default-hero') || '';
      if (!hero || !fallback) return;
      heroToken += 1;
      hero.src = fallback;
      hero.alt = root.querySelector('.hh-bc__title') ? root.querySelector('.hh-bc__title').textContent : '';
      hero.style.opacity = '1';
    }
    function showCurrentSelection() {
      var wanted;
      if (!selected) { restoreDefaultHero(); return; }
      wanted = selected.getAttribute('data-hero') || selected.getAttribute('data-image') || '';
      if (hero && wanted) {
        heroToken += 1;
        hero.src = wanted;
        hero.alt = selected.getAttribute('data-name') || '';
        hero.style.opacity = '1';
      }
      swapPdpGallery(selected);
    }

    function showDisc(disc) {
      selected = disc;
      if (hero) {
        /* Preload, then swap. Setting src directly left the frame dimmed on a stale image while
           the new one downloaded, which read as a slow, sticky click. A token guards against a
           fast second click landing an earlier image last. */
        var wanted = disc.getAttribute('data-hero') || disc.getAttribute('data-image') || '';
        var name = disc.getAttribute('data-name') || '';
        if (wanted && wanted !== hero.getAttribute('src')) {
          var token = ++heroToken;
          hero.style.opacity = '.35';
          var pre = new Image();
          pre.onload = function () {
            if (token !== heroToken) return;
            hero.src = wanted;
            hero.alt = name;
            hero.style.opacity = '1';
          };
          pre.onerror = function () {
            if (token !== heroToken) return;
            hero.src = wanted;
            hero.alt = name;
            hero.style.opacity = '1';
          };
          pre.src = wanted;
        }
      }
      swapPdpGallery(disc);
    }
    /* Names what the ADD button will actually post, in pack order, e.g. "Blue x2, Red x1".
       Shown only while the previewed colour has no quantity, which is exactly the state in
       which the screen (a previewed hero) and the button (the pack) disagree. This is what
       makes an always-armed CTA safe. */
    function packNote() {
      var order = [];
      var counts = {};
      var index;
      var id;
      var disc;
      var parts = [];
      for (index = 0; index < chosen.length; index += 1) {
        id = String(chosen[index]);
        if (!counts[id]) { counts[id] = 0; order.push(id); }
        counts[id] += 1;
      }
      for (index = 0; index < order.length; index += 1) {
        disc = discFor(order[index]);
        parts.push((disc ? (disc.getAttribute('data-name') || 'Item') : 'Item') + ' x' + String(counts[order[index]]));
      }
      return parts.length ? (copyPackNote + ' ' + parts.join(', ')) : '';
    }
    function tapDisc(disc) {
      /* Not while an add is in flight. settle() reconciles against the variant it
         captured, so a colour switch here would print that colour's remainder, and
         its quantity, beside a different disc. The discs already read as inert for
         the same moment the Add button is disabled. */
      if (!disc || adding || disc.getAttribute('data-available') !== 'true') return;
      var variantId = disc.getAttribute('data-variant-id');
      /* The seeded colour is a suggestion the card made, not a choice the shopper made, so the
         first tap on ANY disc replaces it outright instead of running the two-tap preview
         against it. Both failure paths this closes were reproduced on staging 2026-09-21:

         - Tapping a DIFFERENT colour only previewed it. `chosen` still held the seed and the
           add path posts `chosen`, so a shopper looking at a previewed Red added Black.
         - Tapping the SEEDED colour pushed a second unit, because countFor() was already 1 so
           firstTap computed false and the tap fell through to the append branch.

         Replacing rather than clearing matters: clearing would empty `chosen` and send the
         button back to its disabled state, which is the defect the seed exists to remove. */
      if (seededVariant && variantId) {
        seededVariant = null;
        chosen = [variantId];
        showDisc(disc);
        syncChoiceUi(false);
        render();
        return;
      }
      var firstTap = countFor(variantId) === 0 && selected !== disc;
      /* The first body tap only previews. A second body tap, or any body tap once the
         colour has a quantity, appends one unit and preserves the shopper's chosen order. */
      showDisc(disc);
      /* In pair mode the slot is the preview, so a second tap to commit would be a tax on a
         card that is already losing shoppers at this step. One tap fills the next empty slot. */
      if (pairMode) pairCommit(disc);
      else if (!firstTap) chosen.push(variantId);
      syncChoiceUi(false);
      render();
    }
    function changeChoice(disc, change) {
      var variantId;
      var removeAt;
      if (!disc || adding || disc.getAttribute('data-available') !== 'true') return;
      variantId = disc.getAttribute('data-variant-id');
      if (change !== 1 && change !== -1) return;
      /* A zero-count stepper only belongs to the active preview. Its minus control dismisses
         that preview. At a positive count, either control also makes this the viewed colour. */
      if (countFor(variantId) === 0 && disc !== selected) return;
      /* Placed AFTER every early return on purpose. Using the stepper makes the seeded quantity
         the shopper's own, so a later tap on another disc must not wipe it. Clearing this before
         the guards above would hand a no-op stepper press the power to un-arm the replace path
         and let the wrong-colour bug back in. */
      seededVariant = null;
      if (change > 0) {
        showDisc(disc);
        chosen.push(variantId);
      } else if (countFor(variantId) > 0) {
        showDisc(disc);
        removeAt = chosen.lastIndexOf(variantId);
        chosen.splice(removeAt, 1);
      } else {
        /* Dismissing the preview. Handing `selected` back to the last colour that is actually
           in the order is what keeps the screen and the CTA agreeing. The previewArmed gate this
           once protected was removed 2026-09-22; packNote() now carries that job. Handing
           `selected` back still matters: nulling it would leave the gallery on a colour the
           shopper just dismissed while the button posts a different one, and packNote() would
           not fire because it keys off `selected`. */
        selected = chosen.length ? discFor(chosen[chosen.length - 1]) : null;
        if (selected) showDisc(selected);
      }
      syncChoiceUi(change < 0 && selected === null);
      render();
    }
    function render() {
      window.setTimeout(syncShopPay, 0);
      var staged = pendingHint;
      pendingHint = '';
      var status = cartState && cartState.status;
      var chosenCount = chosen.length;
      var pricing = chosenCount ? priceFor(chosenCount) : null;
      var pairPricing = null;
      /* An incomplete pair must not be addable. The button names the remaining step at one
         slot, and a control that names a step while performing an add is the same defect the
         empty-state copy was written to kill. The single-unit path is the explicit link. */
      /* The button may never post a colour the shopper is not looking at. Before this gate the
         CTA tested only `chosen`, so previewing a colour with zero quantity left it enabled over
         a DIFFERENT colour's entry: land, tap Red, tap Red, tap Blue, and the cart received Red
         while Blue filled the screen. That path is reachable on the live theme today in three
         taps and is the reason the first seeding attempt was reverted, so seeding safely means
         closing it rather than routing around it.

         The rule is simply that the previewed colour must be in the order. `!selected` keeps the
         no-preview state addable, which is where changeChoice's dismiss branch leaves things.
         Pair mode is exempt: its slots are the preview and chosenCount already gates it.

         SUPERSEDED 2026-09-22 BY THE OWNER. The note that stood here accepted, as a known
         cost, that a shopper holding Blue at quantity 1 who tapped Red just to look at it
         watched the Add button go dim and fall back to "Tap + to add". It was raised again as
         the PDP "still being glitchy", and it is the single thing that makes this card feel
         broken: browsing a colour silently disarms a button the shopper had already earned.
         Browsing is not a pack edit and must never disarm the CTA.

         The gate existed to close a real mis-ship, and that path is still real: tap Red, tap
         Red, tap Blue, and `chosen` holds Red while the gallery fills with Blue, so a live
         button posts a colour nobody is looking at. Arming the button ALONE would reopen it.
         What closes it instead is naming the pack next to the button whenever the previewed
         colour is not in it, which is the packNote() hint below. The CTA itself stays
         count-only ("Add 3 to Cart", owner's choice 2026-09-22) because 74% of multi-unit
         orders are mixed colour, so no short label can honestly name a colour. The count is
         always true of the pack; the hint says which colours that count refers to. */
      var eligible = status === 'resolved' && chosenCount > 0 && !!pricing && !adding && (!pairMode || chosenCount >= pairSize);
      var summaryText = '';
      var selectedText = '';
      var hintText = '';
      var selectedCount = 0;
      var progressText = String(chosenCount) + ' selected';

      setDiscState();
      renderMeter(chosenCount);
      if (selected) {
        selectedCount = countFor(selected.getAttribute('data-variant-id'));
        selectedText = (selected.getAttribute('data-name') || '') + ', quantity ' + String(selectedCount) + '.';
      }

      if (pricing) {
        summaryText = String(chosenCount) + ' ' + (chosenCount === 1 ? copyItem : copyItemPlural) + '. ' + money(pricing.total, moneyFormat) + '.';
        if (summaryCompare) {
          summaryCompare.textContent = pricing.savings > 0 ? money(pricing.compare, moneyFormat) : '';
          summaryCompare.hidden = pricing.savings <= 0;
        }
        if (summaryTotal) summaryTotal.textContent = money(pricing.total, moneyFormat);
        /* Re-shown here because the empty branch now hides it. Init sets the TEXT once; the
           visibility became a per-render concern on 2026-09-21. */
        if (summaryCurrency) summaryCurrency.hidden = !currencyCode;
      } else {
        summaryText = '0 ' + copyItemPlural + '. ' + money(0, moneyFormat) + '.';
        if (summaryCompare) { summaryCompare.textContent = ''; summaryCompare.hidden = true; }
        /* BLANK, not $0.00. Owner 2026-09-21. The PDP now lands in the previewing state with the
           total at 40px, so an empty order painted a big green $0.00 as the first thing under the
           colour rail: a price that is loudly, precisely wrong. Nothing is lost by omitting it,
           because the CTA 8px below already reads "Tap + to add" and carries the unit price.

           `summaryText` above deliberately still says "0 items. $0.00." A sighted shopper reads
           the empty slot from the surrounding state; a screen reader user has no such context
           and needs the total stated, so the visual and the spoken strings diverge on purpose.

           `.hh-bc__summary-prices` carries a 48px min-height so this does not collapse the row
           and shift the CTA up on the first tap. */
        if (summaryTotal) summaryTotal.textContent = '';
        if (summaryCurrency) summaryCurrency.hidden = true;
      }
      if (summary) summary.hidden = false;

      /* Two taps commit a colour: the first previews it, the second adds it. Once a colour is
         previewing, the button names the remaining step instead of repeating the first step.
         The configured case stays intact here because CSS owns the visual uppercase treatment. */
      paintPair();
      if (pairMode) {
        /* The pair price already sits above the slots, so the button names the remaining step
           rather than repeating a price the shopper can see. It only carries a total once the
           pair is complete and the control actually does something. */
        if (add) {
          if (chosenCount < pairSize) {
            /* The label names the offer and its price in EVERY state, so the control reads as one
               object whose only change is its fill. Naming the step on the button instead was the
               older fix for a dead-feeling control, but it cost the price on the surface that
               carries the funnel, and it made the primary action read as an instruction. The
               remaining step now has its own home: the hint below is published proactively on the
               same tick, aria-disabled still says the control is not ready, and a tap on the
               dimmed button still stages the step. So the button can stay honest about the offer
               without pretending to be enabled.

               BOTH pair branches keep their price. Only the BUILDER's enabled button gave one
               up, and only because its total sits directly above it with the currency code
               attached: 16px on a phone, and the 8px figure quoted here before was a desktop
               only override.
               Pair mode has no such neighbour, so see the note on the complete-pair branch
               below. On top of that this branch is disabled, and a dimmed control reading only
               "Add to Cart" announces an action it will not perform. */
            pairPricing = priceFor(pairSize);
            setAddLabel(copyCta + ' \u00b7 ' + money(pairPricing ? pairPricing.total : 0, moneyFormat), null);
          } else {
            /* PAIR MODE KEEPS ITS PRICE. The builder's button gave one up because its total sits
               directly above it, 16px on a phone; that reasoning does not transfer here, because
               pair mode renders no [data-summary] at all (hh-buy-card.liquid gates it on
               hh_mode != 'pair'). Strip this button's price and the only live pair price LEFT
               would be
               [data-pair-total], up in the intro stack above the media frame, the slots and the
               rail: measured 818 to 874px from this button at 375x812, so the two could never
               share a screen on the phone that is most of our traffic. With the price kept here
               there are two, which is the point.

               Passing `pricing` here is also load-bearing rather than incidental. setAddLabel
               appends a struck compare price whenever savings are positive, and a complete pair
               always has savings, so dropping the total while keeping this argument produced a
               button reading "Add to Cart" beside a crossed-out $43.98 with no live number
               anywhere near it. */
            setAddLabel(copyCta + ' \u00b7 ' + money(pricing ? pricing.total : 0, moneyFormat), pricing);
          }
        }
      } else if (chosenCount === 0) {
        /* Name the step that is actually available, and keep the unit price beside it so the
           first commercial question is still answered on the button itself. Naming the action
           here instead made a disabled control read as an enabled one: the button said
           ADD TO CART, carried a price, and did nothing when tapped. */
        if (add) add.textContent = (selected ? copyCtaPreview : copyCtaEmpty) + ' \u00b7 ' + money(localBaseCents, moneyFormat);
      } else if (add) {
        /* The button names the quantity it will add. It replaces the separate count line that
           used to sit under the button: same fact, read at the moment of the decision instead of
           after it, and one less element between the price and the CTA. A split on the token
           rather than a regex, so a label containing regex metacharacters cannot misbehave, and
           a label with the token removed simply renders unchanged rather than throwing. Only the
           ENABLED builder branch: the disabled branches name the step that is missing, and pair
           mode is fixed at two and carries a total instead. */
        add.textContent = copyCtaCount.split('{count}').join(String(chosenCount));
      }
      if (status !== 'resolved') {
        hintText = staged || (status === 'unresolved' ? 'Cart could not be verified. Refresh to continue.' : 'Updating cart. Add to Cart will be ready in a moment.');
        if (hint) { hint.textContent = hintText; hint.hidden = false; }
        if (liveStatus) liveStatus.textContent = progressText + '. ' + selectedText + ' ' + summaryText + ' ' + hintText;
        setAddDisabled(true);
        return;
      }
      if (!validNumber(localBaseCents) || !tiers.length || (chosenCount && !pricing)) {
        hintText = staged || 'Pricing could not be verified. Please refresh to continue.';
        if (hint) { hint.textContent = hintText; hint.hidden = false; }
        if (liveStatus) liveStatus.textContent = progressText + '. ' + selectedText + ' ' + summaryText + ' ' + hintText;
        setAddDisabled(true);
        return;
      }
      /* Owner 2026-09-22. The CTA is now armed over the PACK even while the shopper previews a
         colour that is not in it, so this line carries the safety: it names exactly what the
         button will post, in pack order, for as long as the screen and the button disagree. A
         staged message (an add outcome, a refusal) always outranks it, because that is a direct
         answer to something the shopper just did. */
      hintText = staged;
      if (!hintText && !pairMode && chosenCount && selected && countFor(selected.getAttribute('data-variant-id')) === 0) {
        hintText = packNote();
      }
      /* Progress only. The EMPTY-state line ("Pick 2 colors. Ships free.") is deliberately not
         published here any more: with the heading "Pick your colors" directly above and two
         empty wells each captioned "Tap to choose", it was the third instruction to pick a
         colour inside one screen. It is not lost, it is deferred: tapping the dimmed button
         still stages it (see pendingHint below), so the answer arrives exactly when a shopper
         asks the question.

         Owner, 2026-09-21: the 1-of-2 line goes the same way. It sat permanently under a filled
         slot narrating a state the two wells already show, one filled and one still captioned
         "Tap to choose", so it read as chatter rather than instruction.

         It is deferred, NOT deleted. pendingHint below still stages it when a shopper taps the
         dimmed button, which is the moment the question is actually being asked. Deleting that
         path too would leave a dead button with no explanation, which is the precise defect the
         staged hint was added to close.

         Note for anyone tempted to hide this node in CSS instead: do not. The same element
         carries the cart-verification and pricing-verification failures written in the two
         guarded branches above, and hiding it would silence real errors. */
      if (hint) { hint.textContent = hintText; hint.hidden = !hintText; }
      /* hintText, NOT staged. packNote() is the whole safety story behind an always-armed CTA,
         and [data-hint] is a plain <p hidden> with no live attribute, so announcing only
         `staged` left a screen-reader shopper hearing "Blue, quantity 0" beside "Add 2 to Cart"
         with nothing saying the button posts Red. That cohort was strictly better off when the
         button was disabled, which is not an acceptable trade. Fable caught this 2026-09-22. */
      if (liveStatus) liveStatus.textContent = progressText + '. ' + selectedText + ' ' + summaryText + (hintText ? ' ' + hintText : '');
      setAddDisabled(!eligible);
    }

    function replaceDrawer(data) {
      var html = data && data.sections && data.sections['cart-drawer-section'];
      var wrap;
      var fresh;
      var drawer;
      if (!html) { window.location.reload(); return false; }
      wrap = document.getElementById('shopify-section-cart-drawer-section');
      fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
      if (wrap && fresh) wrap.replaceWith(fresh);
      drawer = document.getElementById('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.setAttribute('open', '');
      }
      return true;
    }
    function standardCart(cart) {
      var currencyCode = cart && cart.currency ? String(cart.currency) : '';
      return {
        id: cart && cart.token ? String(cart.token) : '',
        totalQuantity: Number(cart && cart.item_count) || 0,
        cost: { totalAmount: { amount: ((Number(cart && cart.total_price) || 0) / 100).toFixed(2), currencyCode: currencyCode } },
        lines: cart && Array.isArray(cart.items) ? cart.items.map(function (item) {
          return { id: String(item.key || item.id || ''), quantity: Number(item.quantity) || 0, cost: { totalAmount: { amount: ((Number(item.final_line_price) || 0) / 100).toFixed(2), currencyCode: currencyCode } } };
        }) : []
      };
    }
    function dispatchCartUpdate(items, data, cart) {
      var detail = { didError: false, itemCount: Number(cart && cart.item_count) || 0, items: cart && cart.items, sections: data.sections, source: 'hh-buy-card' };
      var event = new Event('shopify:cart:lines-update', { bubbles: true });
      event.action = 'add';
      event.context = 'cart';
      event.lines = items.map(function (item) { return { merchandiseId: String(item.id), quantity: item.quantity }; });
      event.detail = { source: 'hh-buy-card' };
      event.promise = Promise.resolve({ cart: standardCart(cart), detail: detail });
      (document.querySelector('#shopify-section-cart-drawer-section cart-items-component') || document).dispatchEvent(event);
    }
    /* Surface attribution. Three instances of this card exist (homepage pair, homepage builder
       and PDP) and nothing has ever distinguished them once an order lands, which makes any
       claim about which one sells unfalsifiable. GA4 is not in this page at all: it runs inside
       Shopify's web pixel sandbox, so this file cannot call gtag. Shopify.analytics.publish is
       the only route out of the page, and a custom pixel subscribes and forwards to GA4.
       Deliberately NOT carried on the cart. Line item properties stop identical variants
       merging, so the same colour added here and on the PDP would render as two lines of one
       and read as a bug. Cart attributes are last-write-wins for the whole cart, so they record
       only the last surface touched, never the split. The add payload above is untouched.
       Success only, and only the parsed-2xx branch, which is the single outcome that confirms
       the whole line without consulting a cart delta. Refused, partial and unconfirmed adds stay
       silent rather than attribute a quantity this card cannot prove it added.
       hh_quoted_value is what this card QUOTED for this add, the same number on the button. It
       is not revenue: priceFor() ignores what is already in the cart and rounds up, so it can
       overquote. The name is meant to make that impossible to mistake in GA4. */
    function publishSurfaceAdd(items) {
      var analytics = window.Shopify && window.Shopify.analytics;
      var pricing;
      if (!analytics || typeof analytics.publish !== 'function') return;
      try {
        pricing = priceFor(items.length);
        analytics.publish('hh_buy_card_add', {
          hh_surface: placement + '_' + mode,
          hh_placement: placement,
          hh_mode: mode,
          hh_quantity: items.length,
          hh_quoted_value: pricing ? pricing.total / 100 : null,
          hh_currency: currencyCode || null
        });
      } catch (error) {
        /* Attribution may never raise on an add the shopper has already been told succeeded. */
      }
    }
    /* Every cart read started while `adding` is true has to be bounded. A read that never
       settles holds Add disabled for the rest of the session, which is this file's oldest
       failure mode, and the recovery paths below start reads on outcomes that previously
       just cleared and moved on: without this the change would ADD ways to reproduce it.
       The bound is not a guess about what the server did. A timed-out read routes into the
       same unknown handling as any other failed read, which now reconciles rather than
       assuming. The POST itself is deliberately not bounded here: a hung POST holds the
       button exactly as it does on live today, and that one belongs to a shared decision
       across this file and hh-pack-builder. */
    var CART_READ_TIMEOUT = 15000;
    function within(promise) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timer = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          reject(new Error('Cart read timed out'));
        }, CART_READ_TIMEOUT);
        promise.then(function (value) {
          if (settled) return;
          settled = true; window.clearTimeout(timer); resolve(value);
        }, function (error) {
          if (settled) return;
          settled = true; window.clearTimeout(timer); reject(error);
        });
      });
    }
    /* Shared tail for every outcome the server may have applied but we could not read
       back. Emptying the chosen order is what stops a second tap from re-ordering what
       already landed. The empty selection gates the CTA until the shopper makes new picks.
       Re-read cart truth so a later visibility or pageshow refresh
       cannot resolve the old quantity. The outcome is restated after the read
       because refresh() renders as it goes and consumes whatever is staged.
       `run` is the attempt this message belongs to. The read below is not cancellable and
       can land after the shopper has started another add, and restating a dead message
       over a live transaction is its own way of getting the count wrong. */
    function unconfirmed(run, message) {
      adding = false;
      chosen = [];
      selected = null;
      pairFollowChosen();
      syncChoiceUi(true);
      pendingHint = message;
      render();
      /* hh-cart-truth's emit() has no per-listener guard, so a throw inside ANY subscriber's
         render escapes refresh() synchronously. unconfirmed() is called from inside .catch
         handlers, where such a throw would escape the chain entirely. */
      within(Promise.resolve().then(function () {
        return window.HHCartTruth.refresh();
      })).catch(function () {}).then(function () {
        if (run !== attempt) return;
        pendingHint = message;
        render();
      });
    }
    /* A 2xx that is not JSON is not an add. A challenged request is answered with an HTML
       page and fetch follows the redirect, so response.ok on its own would report a
       confirmed add for a request the server refused, and the shopper would be sent to
       review a cart nothing was put in. A truncated JSON body still carries the JSON
       content type, so the case `posted` exists to protect stays protected. Unreadable
       headers count as not-an-add: that is only a weaker message now, because the failure
       paths below read the cart instead of guessing. */
    function addedJson(response) {
      var type = response.headers && response.headers.get ? response.headers.get('content-type') : '';
      return String(type || '').indexOf('json') > -1;
    }
    /* Same synchronous-throw guard as unconfirmed(): afterAdd() calls refresh(), and one
       verify() call site is inside a .catch. */
    function verify(items, data, rejected) {
      return within(Promise.resolve().then(function () {
        return window.HHCartTruth.afterAdd(items);
      })).then(function (report) {
        return { data: data, report: report, rejected: rejected };
      });
    }
    function addToCart() {
      var items;
      var before = {};
      var requestedByVariant = {};
      /* The cart quantities for these colours BEFORE the POST. afterAdd() takes its own
         baseline when it is called, which is after the response has arrived, so any
         visibilitychange, pageshow or drawer-driven refresh that lands in between
         publishes the post-add quantity and makes afterAdd() report that nothing was
         added. That is the five-unit bug this whole change exists to kill, arriving
         through a different door, so the baseline is taken here instead. */
      /* Once the POST lands, nothing downstream may claim the add failed. The shopper can see
         the item in the drawer, so "that did not go through" reads as a contradiction and
         invites a second add. Verified 2026-08-03: blocking the follow-up /cart.js read left a
         successfully added item on screen under a failure message. */
      var posted = false;
      /* A refused add is a separate case from a failed one: Shopify can land part of the
         requested quantity and still answer 422, so if the cart read below also fails we
         know neither what landed nor that nothing did. */
      var rejected = false;
      var run;
      if (!add || adding) return;
      if (add.getAttribute('aria-disabled') === 'true' || !chosen.length) {
        /* A tap on the dimmed button used to return in silence, which reads as a dead control
           on the surface that carries the whole funnel. Say what the remaining step is instead.
           The message is STAGED, not written to `hint` directly: render() rewrites hint in every
           one of its branches and the render below would erase it on the same tick. Same reason
           pendingHint exists for addToCart's own outcomes.
           Only the genuinely-nothing-selected case speaks. While the cart is unresolved or
           mid-add, render() already publishes a better message and staging here would outrank
           it, because its branches read `staged ||` first. */
        /* Owner 2026-09-22, from the Fable audit. An unresolved cart used to be terminal for
           the page view: hh-cart-truth gives up after two retries (500ms, 1500ms), the button
           goes dead with "Cart could not be verified. Refresh to continue.", and the only
           recoveries were a tab switch or a back-navigation. Three dropped /cart.js reads inside
           ~2s is an ordinary event on the in-app WebView over cellular, which is most of our
           traffic, and `hh-bc-live` has already hidden Horizon's native Add by then, so the
           shopper is left with no way to buy at all.

           A tap on the dead button is the shopper asking for exactly one thing, so spend it on
           a real retry. refresh() takes ownership of the status, republishes 'loading' (which
           render() already narrates), and either resolves or fails closed again. Nothing is
           added and nothing is posted: this only re-reads /cart.js. */
        if (cartState && cartState.status === 'unresolved' && window.HHCartTruth && window.HHCartTruth.refresh) {
          /* Wrapped like every other refresh() call site: cart-truth's emit() has no per-listener
             guard, so a throw in any subscriber's render() escapes synchronously before .catch
             attaches and surfaces as an uncaught error inside this click handler. */
          Promise.resolve().then(function () { return window.HHCartTruth.refresh(); }).catch(function () {});
          return;
        }
        if (cartState && cartState.status === 'resolved') {
          if (pairMode && chosen.length && chosen.length < pairSize) pendingHint = copyPairCtaSecond;
          else if (!chosen.length) pendingHint = pairMode ? copyPairCtaFirst : (selected ? copyCtaPreview : copyCtaEmpty);
          /* Order is non-empty but the previewed colour is not in it. Without this the dimmed
             button says nothing at all in the one state a shopper is most likely to read as
             broken: a built multi-colour order, a real price on screen, and no response. */
          /* The previewing branch that used to sit here is GONE. Previewing no longer disables
             the button, so the only state that still reached it was a page-wide pricing failure,
             where staging "Tap + to add" replaced "Pricing could not be verified" with an
             instruction that cannot succeed. render() publishes packNote() for the preview case.
             Fable caught this 2026-09-22. */
          if (pendingHint) render();
        }
        return;
      }
      adding = true;
      /* Committed. Whatever happens next, this is no longer an untouched suggestion. */
      seededVariant = null;
      attempt += 1;
      run = attempt;
      render();
      items = chosen.map(function (choice) {
        var variantId = String(choice);
        if (typeof before[variantId] === 'undefined') before[variantId] = Number(cartState.byVariant && cartState.byVariant[variantId]) || 0;
        requestedByVariant[variantId] = (requestedByVariant[variantId] || 0) + 1;
        return { id: Number(variantId), quantity: 1 };
      });
      /* The chosen order is only left armed when the cart has been read back and shown not
         to contain the add. Every uncertain or accepted outcome empties it, so another add
         cannot happen until a new selection is made. */
      function settle(transaction) {
        var truth;
        var confirmed;
        var requested = items.length;
        var confirmedByVariant = {};
        var variantId;
        if (!transaction) {
          /* Drawer replacement failed after a successful POST. This used to return without
             clearing `adding`, which left the button disabled for the rest of the session. */
          unconfirmed(run, 'Added. We could not refresh the cart display, so please review your cart.');
          return;
        }
        /* A parsed 2xx confirms the whole line. Shopify answers 422, not 200, when it can
           only add part of what was asked, so the success path needs no cart evidence and
           must not consult any: a delta cannot tell our add apart from another tab, or a
           second card on this page, moving the same colour, and reading one here reports
           phantom partial adds. Same governing rule as hh-pack-builder. */
        if (!transaction.rejected) {
          chosen = [];
          selected = null;
          pairFollowChosen();
          syncChoiceUi(true);
          adding = false;
          /* Ahead of render() and the dispatch. Nothing downstream
             feeds the payload, so there is no ordering requirement in that direction. The real
             hazard is upstream: a throw inside render() lands in this add's .catch, which tells
             the shopper "we could not refresh the cart display" for an add that DID land. That
             add is still a confirmed add and still belongs to this surface, so publishing
             before render() is what stops the event being lost with it. */
          publishSurfaceAdd(items);
          /* render() before the dispatch. A listener that synchronously moves cart truth
             would otherwise render first and consume the message. */
          render();
          dispatchCartUpdate(items, transaction.data, transaction.report && transaction.report.state ? transaction.report.state.raw : null);
          return;
        }
        truth = transaction.report && transaction.report.state && transaction.report.state.byVariant ? transaction.report.state : null;
        /* No cart to reconcile against means the read told us nothing, which is the unknown
           case rather than a failed one. Defensive: afterAdd() only resolves once its own
           read has resolved, so this should not be reachable. */
        if (!truth) {
          unconfirmed(run, 'We could not confirm that. Please check your cart before adding again.');
          return;
        }
        /* Refused. The delta against the PRE-POST baseline is the only evidence there is.
           Counted here rather than taken from report.variants[].confirmed, which is measured
           against afterAdd()'s own late baseline. See `before` above. */
        confirmed = 0;
        for (variantId in requestedByVariant) {
          if (Object.prototype.hasOwnProperty.call(requestedByVariant, variantId)) {
            confirmedByVariant[variantId] = Math.min(requestedByVariant[variantId], Math.max(0, (Number(truth.byVariant[variantId]) || 0) - before[variantId]));
            confirmed += confirmedByVariant[variantId];
          }
        }
        adding = false;
        /* Removing what landed is what makes a retry safe. The UI update happens before the
           render here because the render has to come after the message is staged. */
        /* Same rule after a partial add: whatever survives the filter is what the slots show. */
        chosen = chosen.filter(function (choice) {
          var id = String(choice);
          if (confirmedByVariant[id] > 0) { confirmedByVariant[id] -= 1; return false; }
          return true;
        });
        if (!selected || !countFor(selected.getAttribute('data-variant-id'))) {
          selected = chosen.length ? discFor(chosen[chosen.length - 1]) : null;
        }
        pairFollowChosen();
        syncChoiceUi(true);
        /* No cart event is dispatched on this path: this card and every other cart-truth
           subscriber are right, but the request returned no drawer sections, so the drawer
           and the cart icon stay stale until the next navigation. That is why all three
           messages send the shopper to their cart. */
        if (confirmed >= requested) {
          /* A refusal can still have committed the whole add: 422 is answered per line, and
             the lost-reply path below arrives here having found everything in the cart.
             Calling that a failure is the one message that gets someone charged twice. */
          pendingHint = 'Added. We could not refresh the cart display, so please review your cart.';
        } else if (confirmed > 0) {
          pendingHint = 'The selected color could not be fully added. Please review your cart.';
        } else {
          pendingHint = 'That did not go through. Please try again.';
        }
        render();
      }
      fetch(root.getAttribute('data-cart-add-url'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer-section', sections_url: window.location.pathname })
      }).then(function (response) {
        /* A rejected add is not an unchanged cart. Shopify documents that a request for more
           than the available stock adds the maximum available and STILL answers 422, so
           "please try again" beside an untouched stepper invites a second add of whatever
           did land. Read the cart back either way and let settle() subtract it.
           https://shopify.dev/docs/api/ajax/reference/cart */
        if (!response.ok) { rejected = true; return verify(items, null, true); }
        /* The server has taken the add. Anything that fails from here (a truncated body,
           a failed drawer swap, a failed verification read) must never tell the shopper
           the add did not happen, or they add again and get charged twice. */
        posted = addedJson(response);
        return response.json().then(function (data) {
          if (!replaceDrawer(data)) return null;
          return verify(items, data, false);
        });
      })
        .then(settle)
        .catch(function () {
          if (posted) { unconfirmed(run, 'Added. We could not refresh the cart display, so please review your cart.'); return; }
          if (rejected) { unconfirmed(run, 'We could not confirm that. Please check your cart before adding again.'); return; }
          /* No response at all. That does not prove the request never reached Shopify: the
             cart can commit the add and the reply still be lost, and guessing "it failed"
             there hands back an armed quantity to re-add. Read the cart and reconcile
             against what is actually in it. Only when that read fails too is nothing
             knowable, and then chosen is emptied rather than risk ordering it twice.
             The two-argument then() is deliberate: a throw inside settle() must not be
             mistaken for a failed read and reset a quantity settle() already handled. */
          rejected = true;
          verify(items, null, true).then(settle, function () {
            unconfirmed(run, 'We could not confirm that. Please check your cart before adding again.');
          });
        });
    }

    discs.forEach(function (disc) {
      var body = disc.querySelector('[data-disc-body]');
      var controls = disc.querySelectorAll('[data-choice-change]');
      var controlIndex;
      if (!body) return;
      body.addEventListener('click', function () { tapDisc(disc); });
      body.addEventListener('keydown', function (event) {
        var index = available.indexOf(disc);
        var next;
        if (event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) return;
        event.preventDefault();
        next = event.keyCode === 37 || event.keyCode === 38 ? index - 1 : index + 1;
        if (next < 0) next = available.length - 1;
        if (next >= available.length) next = 0;
        if (available[next]) available[next].querySelector('[data-disc-body]').focus();
      });
      for (controlIndex = 0; controlIndex < controls.length; controlIndex += 1) {
        controls[controlIndex].addEventListener('click', function (event) {
          event.stopPropagation();
          if (event.currentTarget.getAttribute('aria-disabled') === 'true' || adding) return;
          changeChoice(disc, Number(event.currentTarget.getAttribute('data-choice-change')));
        });
      }
    });
    root.addEventListener('click', function (event) {
      var clicked = event.target;
      /* === null, not truthiness. A bare `data-add` attribute returns '' which is falsy,
         so the truthy walker climbed straight past the button and Add to Cart did nothing.
         Same bug class as the inert 'Add 1 More' control in July. */
      while (clicked && clicked !== root && clicked.getAttribute('data-add') === null) clicked = clicked.parentNode;
      if (!clicked || clicked === root) return;
      addToCart();
    });
    window.HHCartTruth.subscribe(function (nextState) { cartState = nextState; render(); });
    /* Progressive enhancement, copied from the rail's contract in buy-buttons.liquid: the CSS
       that hides Horizon's native quantity and Add to Cart is gated on this class, which is only
       added once the card has actually booted. If our JS never runs, the native controls stay and
       the shopper can still buy. Horizon's quick-add clones this markup via DOMParser, where
       injected scripts never execute, so an unconditional hide would leave no way to buy at all. */
    var pdpHost = root.parentNode;
    while (pdpHost && pdpHost !== document.body) {
      if (pdpHost.className && String(pdpHost.className).indexOf('hh-pr-host-pdprail') > -1) {
        if (String(pdpHost.className).indexOf('hh-bc-live') < 0) pdpHost.className += ' hh-bc-live';
        break;
      }
      pdpHost = pdpHost.parentNode;
    }
    var discWrap = root.querySelector('.hh-bc__discs');
    if (discWrap) {
      discWrap.addEventListener('touchstart', warmHeroes, { passive: true });
      discWrap.addEventListener('mouseenter', warmHeroes);
      discWrap.addEventListener('focusin', warmHeroes);
    }
    /* Pair wiring. The rail's per-colour steppers are the multi-quantity control and they do
       not belong in a mode whose whole point is that the slot count is the quantity, so they
       are removed from the accessibility tree here rather than merely hidden by CSS. */
    if (pairMode) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-disc-stepper]'), function (stepper) {
        stepper.hidden = true;
        stepper.setAttribute('aria-hidden', 'true');
      });
      pairSlots.forEach(function (slot, index) {
        slot.addEventListener('click', function () { pairSelect(index); });
      });
      paintPairPrice();
    }
    /* Product description disclosure. Animates a MEASURED pixel height: `height:auto` cannot be
       transitioned, and guessing a max-height leaves the easing running against a value the
       content never reaches, which reads as a stall then a snap. After the transition the panel
       is set back to auto so a late-loading font or an image reflow cannot clip it. */
    (function () {
      var trigger = root.querySelector('[data-disclose]');
      var panel = root.querySelector('[data-disclose-panel]');
      var busy = false;
      if (!trigger || !panel) return;
      /* Derived, never passed in. A close leaves a 260ms timer running; reopening before it
         fires used to let the DEAD close settle the LIVE open, ending at aria-expanded="true"
         with the panel hidden. Reading the current state makes a stale callback a no-op. */
      function settle() {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        busy = false;
        panel.hidden = !open;
        if (open) panel.style.height = 'auto';
      }
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') !== 'true';
        var target;
        if (busy) return;
        busy = true;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          panel.hidden = false;
          panel.style.height = '0px';
          /* Read back to force the layout before the target height is written, or the browser
             coalesces both writes and there is nothing to transition from. */
          target = panel.scrollHeight;
          panel.setAttribute('data-open', 'true');
          panel.style.height = String(target) + 'px';
        } else {
          panel.style.height = String(panel.scrollHeight) + 'px';
          panel.scrollHeight;
          panel.removeAttribute('data-open');
          panel.style.height = '0px';
        }
        /* transitionend is not guaranteed: a zero-duration computed transition under reduced
           motion never fires one. The timer is the floor, and the handler is idempotent. */
        window.setTimeout(settle, 260);
      });
      panel.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'height') return;
        settle();
      });
    }());
    /* Land BUYABLE. Measured on the live theme 2026-09-21: every visitor arrived on an
       aria-disabled Add button reading "Pick a color to start", cursor not-allowed, zero colours
       chosen, and a 32px $0.00 sitting directly above it. That is the exact stage that halved
       this year: session to add-to-cart ran 9.00% in April and 4.64% in September, while
       everything downstream of the cart held or improved. One tap to a valid cart, not two.

       The seed is a SUGGESTION. tapDisc() replaces it on the first tap of any disc and
       changeChoice() adopts it, which is what keeps the button from ever disagreeing with the
       disc on screen. Read the comment in tapDisc() before changing anything here. */
    /* Deliberately NOT re-run after a successful add. Re-seeding there would leave the CTA
       armed over a unit the shopper never chose, so a stray second tap on the button posts
       another one: exactly the guarantee the comment above items[] gives up. It would also
       stage from `available`, which is a one-time snapshot of the initial markup and cannot
       know that the add just took the last unit of that colour. The card resetting to its
       empty state after an add is the safety property, not an oversight. */
    function seedDefault() {
      var wanted;
      var match;
      var seedDisc = null;
      var variantId;
      var idInput;
      var index;
      if (!available.length) return;
      /* Owner 2026-09-22: the two-pack now lands with BOTH slots filled with the rail-first
         colour (Black whenever it is in stock), and either slot can still be changed. It used
         to land with two empty wells, which asked the shopper to make two decisions before the
         section showed them anything buyable, and the media column that used to sit above is
         gone, so an empty pair now has no product picture at all.

         The slots are the source of truth in pair mode and `chosen` is derived from them by
         pairSync(), not the other way round, so seed `pairChoice` and let pairSync() build the
         POST payload. Writing `chosen` directly would be undone on the next pairSync(). */
      if (pairMode) {
        variantId = available[0].getAttribute('data-variant-id');
        if (!variantId) return;
        pairChoice[0] = variantId;
        pairChoice[1] = variantId;
        pairSeeded[0] = true;
        pairSeeded[1] = true;
        pairActive = 0;
        selected = available[0];
        pairSync();
        return;
      }
      /* Seed whatever the SERVER already painted, so the card can never contradict the gallery.
         The product form's id input carries Horizon's server-rendered variant, which already
         accounts for a ?variant= landing, the product default, and any sold-out redirect. */
      idInput = root.closest ? root.closest('form') : null;
      idInput = idInput ? idInput.querySelector('input[name="id"]') : null;
      wanted = idInput && idInput.value ? String(idInput.value) : '';
      /* Fallback for placements that render no form. The Meta catalog, Merchant Center and the
         Judge.me review feed all link to variant URLs. Regex rather than URLSearchParams: this
         runs in the Facebook and Instagram WebView, and a plain match on digits cannot throw. */
      if (!wanted) {
        match = /[?&]variant=(\d+)/.exec(window.location.search || '');
        wanted = match ? match[1] : '';
      }
      if (wanted) {
        /* Deliberately NOT the shared discFor() above: that one searches `discs`, which
           includes sold-out colours, and this needs a hit ONLY when the named variant is
           actually buyable. The null return below is what makes a sold-out landing seed
           nothing rather than silently substituting another colour. */
        for (index = 0; index < available.length; index += 1) {
          if (available[index].getAttribute('data-variant-id') === wanted) {
            seedDisc = available[index];
            break;
          }
        }
        /* Named but absent from `available` means sold out. Seeding the rail-first colour here
           would stage a colour the URL, the gallery and the picker all disagree with, and the
           shopper never asked for it. Seed nothing instead: the card holds its empty state and
           the first tap is the only thing that picks a colour. */
        if (!seedDisc) return;
      } else {
        /* available[] is in rail order and the rail is ordered by seller rank, so this is Black
           whenever Black is in stock and falls through to the next in-stock colour when it is
           not. Reached only by a placement with no form and no ?variant=. */
        seedDisc = available[0];
      }
      variantId = seedDisc.getAttribute('data-variant-id');
      /* No id, no seed. Button eligibility only tests count and pricing, so a blank id would arm
         a live CTA over chosen = [null] and post a cart line whose id is Number(null), which is
         0. Refusing to seed leaves the old disabled state, which is wrong but safe. */
      if (!variantId) return;
      selected = seedDisc;
      /* PDP stops at PREVIEWING, by owner decision 2026-09-21. Setting `selected` alone is
         exactly the state a real first tap leaves behind: ring on the disc, stepper open at 0,
         CTA reading "Tap + to add". The card looks tapped without claiming a quantity nobody
         chose, which is the contradiction the fully-seeded version put on screen: a ringed disc
         above a 0, a $0.00 and a disabled button all describing an empty order.

         Stopping here rather than seeding `chosen` is also what makes `seededVariant` the wrong
         tool on this path. Leave it null. Arming it would fire tapDisc's replace branch on the
         first tap of ANY disc and push that colour straight into the order, turning a shopper's
         look at Red into a Red in the cart. With `chosen` empty there is no unearned entry to
         protect, so the ordinary two-tap rules take over untouched: a tap on the previewed disc
         counts as the second tap and adds it, a tap on another disc previews that one instead,
         and the minus control at 0 dismisses the preview.

         The homepage builder card deliberately still seeds a full unit below. Its landing-state
         argument is the one in the comment above this function. */
      if (placement === 'pdp') return;
      chosen.push(variantId);
      seededVariant = variantId;
      /* Imagery is deliberately NOT touched on the landing path. The server already rendered the
         gallery for this variant, so there is nothing to correct, and showDisc() would run
         swapPdpGallery(), which strips srcset and sizes off the PDP gallery image and costs
         every visitor the responsive source set on the LCP image for no visual change. The
         post-add path repaints through syncChoiceUi(true), where the image is no longer LCP. */
    }
    seedDefault();
    syncChoiceUi(false);
    render();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-hh-buy-card]'), function (root) {
      init(root);
      bindRailFade(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());


/* ---------------------------------------------------------------------------
   Product view tiles (front / rear / side / thumb / index).

   Front, rear and side follow the selected colour; the two photographs do not.

   Three things this has to survive, all found in review:

   1. The colour handler above preloads an Image() and writes the front slide in
      its onload. The other four slides have their own image elements now.
   2. Colour can change by arrow key, which never fires a click. Watching
      aria-pressed on the discs catches both paths.
   3. shopify:section:load fires boot() across the document, so a per-card flag
      stops duplicate listeners stacking up.

   Lives in an asset, never inlined: this markup can arrive through the Section
   Rendering API and inline scripts in that HTML never execute.
--------------------------------------------------------------------------- */
(function () {
  function closestEl(node, sel) {
    if (node && node.closest) return node.closest(sel);
    while (node && node.nodeType === 1) {
      if (node.matches ? node.matches(sel) : false) return node;
      node = node.parentNode;
    }
    return null;
  }
  function setOn(el, on) {
    if (on) { el.className = el.className.indexOf('is-on') === -1 ? el.className + ' is-on' : el.className; }
    else { el.className = el.className.replace(/\s*\bis-on\b/g, ''); }
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function init(root) {
    if (root.getAttribute('data-hh-views-ready') === '1') return;
    var views = root.querySelector('[data-views]');
    if (!views) return;
    var media = root.querySelector('[data-media]');
    if (!media) return;
    var hero = root.querySelector('[data-hero]');
    if (!hero) return;
    root.setAttribute('data-hh-views-ready', '1');

    var tiles = Array.prototype.slice.call(views.querySelectorAll('[data-hh-view]'));
    var slides = Array.prototype.slice.call(media.querySelectorAll('[data-hh-slide]'));
    var scrollTimer = 0;

    /* Only the PAIR card starts with no selected colour. In builder mode seedDefault() has
       already marked a disc data-current-choice="true" before this runs (available[0] on the
       homepage, the ?variant= colour on the PDP), so the first branch below usually hits. The
       fallback to the first available disc is what covers pair mode, and it matches the artwork
       Liquid rendered into the opening slides and tiles. */
    function currentDisc() {
      return root.querySelector('.hh-bc__disc[data-current-choice="true"]') ||
        root.querySelector('.hh-bc__disc[data-available="true"]');
    }
    function urlFor(view, small) {
      if (view === 'thumb' || view === 'index') {
        var t = views.querySelector('[data-hh-view="' + view + '"]');
        return t ? t.getAttribute('data-photo') : '';
      }
      var d = currentDisc();
      if (!d) return '';
      var big = d.getAttribute('data-' + view);
      var sm = d.getAttribute('data-' + view + '-sm');
      if (view === 'front' && !big) big = d.getAttribute('data-image') || d.getAttribute('data-hero');
      return small ? (sm || big || '') : (big || '');
    }
    function slideFor(view) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].getAttribute('data-hh-slide') === view) return slides[i];
      }
      return null;
    }
    function setActive(view) {
      for (var i = 0; i < tiles.length; i++) {
        setOn(tiles[i], tiles[i].getAttribute('data-hh-view') === view);
      }
    }
    function scrollToView(view, smooth) {
      var slide = slideFor(view);
      var supportsSmooth = document.documentElement && 'scrollBehavior' in document.documentElement.style;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!slide) return;
      if (smooth && !reduceMotion && supportsSmooth && typeof media.scrollTo === 'function') {
        try {
          media.scrollTo({ left: slide.offsetLeft, top: 0, behavior: 'smooth' });
          return;
        } catch (error) {}
      }
      media.scrollLeft = slide.offsetLeft;
    }
    function paint(view) {
      if (!slideFor(view)) return;
      setActive(view);
      scrollToView(view, true);
    }
    function syncFromRail() {
      var closest = null;
      var distance = Infinity;
      for (var i = 0; i < slides.length; i += 1) {
        var nextDistance = Math.abs(slides[i].offsetLeft - media.scrollLeft);
        if (nextDistance < distance) {
          closest = slides[i];
          distance = nextDistance;
        }
      }
      if (closest) setActive(closest.getAttribute('data-hh-slide'));
    }

    views.addEventListener('click', function (e) {
      var t = closestEl(e.target, '[data-hh-view]');
      if (!t || !views.contains(t)) return;
      e.preventDefault();
      paint(t.getAttribute('data-hh-view'));
    });

    media.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncFromRail, 80);
    }, { passive: true });

    /* The src observer is intentionally absent because data-hero now belongs only to the
       front slide. Reasserting the active view URL would corrupt it whenever another slide is active. */

    /* Colour change, by click or by keyboard. Reset to front and refresh the
       three product slides and their small tile art for the new colour. */
    function onColourChange() {
      var hasSelection = !!root.querySelector('.hh-bc__disc[data-current-choice="true"]');
      setActive('front');
      for (var i = 0; i < tiles.length; i++) {
        var v = tiles[i].getAttribute('data-hh-view');
        if (v === 'front' || v === 'rear' || v === 'side') {
          var tileUrl = urlFor(v, true);
          var tileImg = tiles[i].querySelector('img');
          var slide = slideFor(v);
          var slideImg = slide ? slide.querySelector('img') : null;
          var slideUrl = urlFor(v, false);
          if (tileUrl && tileImg && tileImg.getAttribute('src') !== tileUrl) tileImg.src = tileUrl;
          if ((v !== 'front' || hasSelection) && slideUrl && slideImg && slideImg.getAttribute('src') !== slideUrl) slideImg.src = slideUrl;
        }
      }
      scrollToView('front', false);
    }
    if (window.MutationObserver) {
      var discWrap = root.querySelector('.hh-bc__discs') || root;
      /* oldValue !== 'true' is what makes this a COLOUR CHANGE listener rather than a
         "something re-rendered" listener. setDiscState() rewrites data-current-choice on every
         disc on every render, and setAttribute queues a mutation record even when the value is
         identical, so ~25 same-value records arrive per render. Without this guard a plus tap,
         a second tap on the already-selected colour, a tab return, or any cart refresh counted
         as a colour change and snapped the gallery back to the front view while the shopper was
         looking at the rear or side. Reproduced on the live homepage before this guard existed.
         A record whose final value is 'false' is still ignored, so deselect behaviour is
         unchanged. */
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].attributeName === 'data-current-choice' &&
              muts[i].oldValue !== 'true' &&
              muts[i].target.getAttribute('data-current-choice') === 'true') {
            onColourChange();
            return;
          }
        }
      }).observe(discWrap, { attributes: true, subtree: true, attributeFilter: ['data-current-choice'], attributeOldValue: true });
      /* The card begins with no selected colour. This call keeps the product default image as
         the front-view source until a disc becomes selected, and remains safe after a choice. */
      onColourChange();
    }
  }

  function boot() {
    /* [class*="hh-buy-card-"] also matches three ancestor wrappers
       (hh-buy-card-section, -section-template--..., -section__wrap), so it bound
       the same tiles four times. data-placement is narrower, but NOT unique to this card:
       snippets/hh-purchase-rail.liquid also emits it on its own root. That section is disabled
       on every template today, so this selector currently matches buy cards only. If the rail
       is ever re-enabled, scope this to [data-hh-buy-card] rather than letting init() run over
       a root that has no .hh-bc__disc in it. */
    var cards = document.querySelectorAll('[data-placement]');
    for (var i = 0; i < cards.length; i++) init(cards[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
